import React, { useEffect, useRef, useState } from 'react'
import { HeaderProps } from './types'
import Modal from '../Modal'
import Button from '../Button'
import { useViewPort } from '../../../hooks'
import resolveProps from '../../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'public',
      isDefault: true
    },
    {
      title: 'enterprise'
    }
  ],
  modifiers: [],
  states: []
}

export default function Header(props: HeaderProps) {
  const {
    brandSrc,
    brandHref,
    brandAlt,
    simpleLight,
    children,
    enterprise,
    search,
    data,
    ...rest
  } = props

  const [mobileSearchModalIsVisible, setMobileSearchModalIsVisible] =
    useState(false)
  const [searchFieldIsActive, setSearchFieldIsActive] = useState(false)

  const [state, setState] = React.useState({
    isModalOpen: false
  })

  const renderModal = () => {
    return (
      <Modal
        sm
        accessibility
        data={{
          content: (
            <div className="mdn-Text mdn-Text--body">
              <div>
                Para aumentar ou reduzir a fonte, utilize os atalhos nativos do
                seu navegador:
                <br />
                <ul>
                  <li>
                    <span
                      className="mdn-Icon-verificado mdn-Icon--sm"
                      aria-hidden="true"
                    ></span>{' '}
                    No windows&nbsp;<strong>CTRL</strong>
                    +&nbsp;(para aumentar) e&nbsp;<strong>CTRL</strong>{' '}
                    -&nbsp;(para diminuir)
                  </li>
                  <li>
                    <span
                      className="mdn-Icon-verificado mdn-Icon--sm"
                      aria-hidden="true"
                    ></span>{' '}
                    No macOS (safari)&nbsp;<strong>CMD</strong>+&nbsp;(para
                    aumentar) e&nbsp;<strong>CMD</strong>-&nbsp;(para diminuir)
                  </li>
                </ul>
              </div>
            </div>
          ),
          footer: {
            action: (
              <>
                <Button primary onClick={handleModalClose}>
                  Ok
                </Button>
              </>
            )
          },
          isOpen: state.isModalOpen,
          onCloseClick: handleModalClose
        }}
      />
    )
  }

  const handleModalClose = () => {
    // do something
    setState({
      isModalOpen: false
    })
  }

  const handleModalOpen = () => {
    // do something
    setState({
      isModalOpen: true
    })
  }

  return (
    <>
      <div>
        <header className="mdn-Menu mdn-Header mdn-Menu--logged mdn-isMenuScrolling mdn-isInitialized">
          <div className="mdn-Menu-main ">
            <div className="mdn-Menu-container">
              <nav className="mdn-Menu-content" aria-label="Site menu">
                <div className="mdn-Menu-content-left">
                  <a
                    className="mdn-Menu-logo-link"
                    href={brandHref || '#'}
                    title={brandAlt || 'Clique e confira a página'}
                  >
                    <img
                      className="mdn-Menu-logo"
                      src={
                        brandSrc ||
                        `https://mondrian.claro.com.br/brands/horizontal/inverse/${
                          enterprise ? 'claro-empresas' : 'claro'
                        }.svg`
                      }
                      alt={brandAlt || 'Logo da Claro'}
                    />
                  </a>
                </div>
                <div className="mdn-Menu-content-right">
                  {search && (
                    <ul className="mdn-Menu-top-list mdn-Menu-top-list-right">
                      <li
                        className={`mdn-Menu-top-list-item mdn-Menu-top-list-item--full mdn-Menu-top-list-item-search ${
                          mobileSearchModalIsVisible ? 'mdn-isActive' : ''
                        }`}
                      >
                        <div className="mdn-Menu-top-action-container">
                          <button
                            className="mdn-Input-action-mobile mdn-Menu-top-event mdn-Menu-top-action"
                            type="button"
                            aria-expanded="false"
                            title="Como podemos ajudar?"
                            onClick={(e) => setMobileSearchModalIsVisible(true)}
                          >
                            <span
                              className="mdn-Icon-busca mdn-Icon--md"
                              aria-hidden="true"
                            ></span>
                          </button>

                          <form
                            className="mdn-Menu-search-container"
                            action="https://www.claro.com.br/busca"
                            method="GET"
                            aria-label="Busque o que deseja e pressione o a tecla Enter para obter o resultado. Como podemos te ajudar?"
                          >
                            <div className="mdn-Input-fieldset">
                              <input
                                placeholder="Busca"
                                name="pesquisa"
                                className="mdn-Input-field mdn-Menu-search-action mdn-Menu-search-action--api"
                                aria-label="Insira um texto para busca"
                                required
                                type="text"
                                data-mdn-type="search"
                                onFocus={() => {
                                  setSearchFieldIsActive(true)
                                  setMobileSearchModalIsVisible(true)
                                  document.body.classList.add(
                                    'mdn-Menu-top-isActive'
                                  )
                                }}
                                onBlur={() => {
                                  setSearchFieldIsActive(false)
                                  setMobileSearchModalIsVisible(false)
                                  document.body.classList.remove(
                                    'mdn-Menu-top-isActive'
                                  )
                                }}
                                {...data.searchInputProps}
                              />

                              <button
                                className="mdn-Menu-top-event mdn-Input-search-action mdn-Input-search"
                                title="Busque por algo"
                                type="submit"
                              >
                                <span
                                  className="mdn-Icon-busca mdn-Icon--xxs"
                                  aria-hidden="true"
                                ></span>
                              </button>
                            </div>

                            <button
                              className="mdn-Input-action-close-full mdn-Menu-top-event mdn-Menu-top-action mdn-Button--secondary"
                              type="button"
                              title="Fechar busca"
                              onClick={(e) =>
                                setMobileSearchModalIsVisible(false)
                              }
                            >
                              <span
                                className="mdn-Icon-fechar mdn-Icon--xxs"
                                aria-hidden="true"
                              ></span>
                            </button>
                          </form>
                        </div>
                      </li>
                    </ul>
                  )}
                  {data?.icons && (
                    <ul className="mdn-Menu-list">
                      {data.icons.map((icon, index) => {
                        return (
                          <li
                            key={index}
                            className={`mdn-Menu-${
                              index != 0 ? 'top-' : ''
                            }list-item mdn-Menu-top-list-item-accessibility mdn-Menu-list-item-link`}
                          >
                            <icon.tagName
                              href={icon.href}
                              className="mdn-Menu-top-event"
                              title={icon.title}
                              {...icon}
                            >
                              <span
                                className={`mdn-Icon-${icon.icon} mdn-Icon--sm`}
                                aria-hidden="true"
                              ></span>
                            </icon.tagName>
                          </li>
                        )
                      })}
                      <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-accessibility mdn-Menu-list-item-link">
                        <button
                          className="mdn-Menu-top-event mdn-Modal--handler mdn-isInitialized"
                          title="Modal Zoom texto"
                          data-mdn-modal-id="modal-accessibility-zoom"
                          onClick={handleModalOpen}
                        >
                          <span
                            className="mdn-Icon-diminuir-tamanho mdn-Icon--sm  mdn-Menu-text-icon"
                            aria-hidden="true"
                          ></span>
                          <span
                            className="mdn-Icon-aumentar-tamanho mdn-Icon--sm  mdn-Menu-text-icon"
                            aria-hidden="true"
                          ></span>
                        </button>
                      </li>
                    </ul>
                  )}
                </div>
              </nav>
            </div>
          </div>
        </header>
      </div>
      {data?.icons && renderModal()}
    </>
  )
}
